// extracted by mini-css-extract-plugin
module.exports = {"image-upload__input":"image-upload_image-upload__input__fwBvk","image-upload__button":"image-upload_image-upload__button__UTX4L"};